import type { ReactNode, JSX } from 'react'

import { PageLayout } from '@buffer-mono/popcorn'

import styles from './HomeLayout.module.css'

interface HomeLayoutProps {
  children: ReactNode
}

export function HomeLayout({ children }: HomeLayoutProps): JSX.Element {
  return (
    <PageLayout>
      <div className={styles.layout}>{children}</div>
    </PageLayout>
  )
}
